module.exports = __webpack_public_path__ + "static/img/applicableScene5.0f48156.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/applicableScene5.png
// module id = se7B
// module chunks = 1